// react
import React from "react";
import { Button, Modal } from "react-bootstrap";

// components
import Spinner from "../components/Spinner";

const ConfirmationModal = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.showModal}
        onHide={props.hideModal}
        dialogClassName="modal-dialog-centered"
        className={props.className || "modal-nested"}
        backdropClassName={props.backdropClassName || "modal-nested-backdrop"}
      >
        <Modal.Header onHide={props.hideModal} closeButton>
          <h4 className="modal-title">{props.title}</h4>
        </Modal.Header>
        <Modal.Body>
          <p>{props.message}</p>
          {/* Optionaler Inhalt unter der Meldung — für Rückfragen, die nicht nur ja
              oder nein sind, sondern eine Eingabe brauchen (z. B. der Zuständige
              beim Umwandeln eines Leads, CRM A-IV Punkt 3). Ohne children bleibt das
              Modal genau wie vorher. */}
          {props.children}
        </Modal.Body>
        <Modal.Footer>
          {/* Optionaler zweiter Footer-Button (z.B. "Nein") — steht ohne diesen Prop
              nicht zur Verfuegung, alle anderen Aufrufer bleiben unveraendert. */}
          {props.secondaryButton}
          <Button
            form="form"
            variant="primary"
            // Verhindert das Bestätigen, solange eine Eingabe in `children` fehlt.
            disabled={props.confirmButtonLoading || props.confirmDisabled}
            onClick={(e) => props.confirmHandler(e)}
          >
            {!props.confirmButtonLoading && (
              <div>{props.confirmButtonText}</div>
            )}
            {props.confirmButtonLoading && (
              <Spinner className="spinner-border-sm" tag="span" color="white" />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmationModal;
